<template>
  <div class="core-tech-container">
    <h1 class="page-title">核心技术</h1>
    <div class="tech-grid">
      <div
        v-for="item in currentPageData"
        :key="item.id"
        class="tech-item"
        @click="goToDetail(item.id)"
      >
        <div class="image-wrapper">
          <img :src="item.image" :alt="item.title">
          <div class="hover-overlay">
            <h3>{{ item.title }}</h3>
          </div>
        </div>
        <div class="text-content">
          <h4 class="item-title">{{ item.title }}</h4>
          <p class="item-description">{{ item.content[0] }}</p>
        </div>
      </div>
    </div>

    <div class="pagination">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="totalItems"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        @current-change="handlePageChange"
      />
    </div>
  </div>
</template>

<script>
import techDetailData from '@/data/techDetailData'

export default {
  name: 'CoreTechnology',
  data() {
    return {
      currentPage: 1,
      pageSize: 9,
      techData: techDetailData
    }
  },
  computed: {
    totalItems() {
      return this.techData.length
    },
    currentPageData() {
      const start = (this.currentPage - 1) * this.pageSize
      const end = start + this.pageSize
      return this.techData.slice(start, end)
    }
  },
  methods: {
    handlePageChange(page) {
      this.currentPage = page
    },
    goToDetail(id) {
      this.$router.push(`/coreTechnology/detail/${id}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.core-tech-container {
  margin: 4% auto 8%;

  .page-title {
    text-align: center;
    margin-bottom: 40px;
    font-size: 32px;
    color: #333;
  }

  .tech-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 30px;
    width: 94%;
    max-width: 1280px;
    margin: auto;
  }

  .tech-item {
    cursor: pointer;
    background: #fff;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease;

    &:hover {
      .image-wrapper {
        img {
          transform: scale(1.1);
        }

        .hover-overlay {
          opacity: 1;

          h3 {
            &::before,
            &::after {
              width: 100%;
            }
          }
        }
      }

      .item-title {
        color: #0555b6 !important;
      }
    }

    .image-wrapper {
      position: relative;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.3s ease;
      }

      .hover-overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.7);
        color: white;
        opacity: 0;
        transition: opacity 0.3s ease;
        display: flex;
        align-items: center;
        justify-content: center;

        h3 {
          width: 80%;
          font-size: 16px;
          font-weight: bold;
          text-align: center;
          padding: 10px;
          position: relative;

          &::before,
          &::after {
            content: '';
            position: absolute;
            width: 0;
            height: 1px;
            background-color: #fff;
            transition: width 0.6s ease;

          }

          &::before {
            top: 0;
            left: 50%;
            transform: translateX(-50%);
          }

          &::after {
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
    }

    .text-content {
      padding: 20px;

      .item-title {
        font-size: 18px;
        color: #333;
        margin-bottom: 10px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        transition: color 0.3s ease;
      }

      .item-description {
        font-size: 14px;
        color: #666;
        line-height: 1.5;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        margin: 0;
      }
    }
  }

  .pagination {
    display: flex;
    justify-content: center;
    margin-top: 40px;
  }
}

@media (max-width: 768px) {
  .tech-grid {
    grid-template-columns: repeat(1, 1fr) !important;
    padding: 20px;
  }
}
</style>
